export default "__VITE_ASSET__bqznf1At__"